export enum CaseLineStatus {
  Approved = 'approved',
  Closed = 'closed',
  Declined = 'declined',
  Open = 'open',
  Submitted = 'submitted',
}
